import {createStylesParams, StyleParamType, wixColorParam, wixFontParam} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {colorMetadata, fontMetadata, numberMetadata} from '../../../../../../utils/builderMetadata'

export type DetailsSectionStylesParams = {
  detailsSectionBackgroundColor: StyleParamType.Color
  detailsSectionBorderColor: StyleParamType.Color
  detailsSectionBorderWidth: StyleParamType.Number
  detailsSectionBorderRadius: StyleParamType.Number
  detailsSectionSubtitleFont: StyleParamType.Font
  detailsSectionSubtitleColor: StyleParamType.Color
  detailsSectionBodyTextFont: StyleParamType.Font
  detailsSectionBodyTextColor: StyleParamType.Color
}

export const detailsSectionStylesParams = createStylesParams<DetailsSectionStylesParams>({
  detailsSectionBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.05),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-5', 0.05),
  },
  detailsSectionBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: (params) => wixColorParam('color-5', params.isMobile ? 1 : 0)(params),
    metadata: colorMetadata(StyleType.borderColor, 'color-5', 0, 1),
  },
  detailsSectionBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 0}),
  },
  detailsSectionBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderRadius, {defaultValue: 0}),
  },

  detailsSectionSubtitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', {size: 16, htmlTag: 'h2'}),

    metadata: fontMetadata('Page-title', 16),
  },
  detailsSectionSubtitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
  detailsSectionBodyTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  detailsSectionBodyTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
})
